import React from 'react';
import ReactPlayer from 'react-player';

function VideoUrlWidget({ value, onChange }) {
  return (
    <div>
      <input
        type="text"
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        className="form-control"
      />
      {ReactPlayer.canPlay(value)
        ? <div className="player-wrapper">
          <ReactPlayer
            url={value}
            controls
            width="300px"
            height="170px"
            style={{ marginTop: '20px' }}
          />
        </div>
        : <div>Please provide a valid video url.</div>}
    </div>
  );
}

export default VideoUrlWidget;



// WEBPACK FOOTER //
// ./src/widgets/VideoUrlWidget.js